module.exports = __webpack_public_path__ + "static/18-f23a8bfffa9418dc75036d0c3e5b8b7a.webp";